module.exports = __webpack_public_path__ + "img/ua.5184d679.svg";